import { render, staticRenderFns } from "./OzDrawerConfirmationDialog.vue?vue&type=template&id=e48ab79c&"
import script from "./OzDrawerConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports